import fetch from 'auth/GenericFetchInterceptorV5';

const normalizeDownloadResponse = (response) => {
    if (typeof response === 'string') {
        return response;
    }

    return response?.url || response?.downloadUrl || response?.signedUrl || response;
};

const PassiveInvoicesService = {
    list({ status, legalEntityId } = {}) {
        const params = new URLSearchParams();
        if (status) params.set('status', status);
        if (legalEntityId) params.set('legalEntityId', legalEntityId);
        const query = params.toString();
        return fetch({
            url: `/api/billing-hub/v1/passive-invoices${query ? `?${query}` : ''}`,
            method: 'GET',
        });
    },

    detail(id, legalEntityId) {
        const query = legalEntityId
            ? `?legalEntityId=${encodeURIComponent(legalEntityId)}`
            : '';
        return fetch({
            url: `/api/billing-hub/v1/passive-invoices/${encodeURIComponent(id)}${query}`,
            method: 'GET',
        });
    },

    async download(id, type = 'json', legalEntityId) {
        const params = new URLSearchParams({type});
        if (legalEntityId) params.set('legalEntityId', legalEntityId);
        const response = await fetch({
            url: `/api/billing-hub/v1/passive-invoices/${encodeURIComponent(id)}/download?${params.toString()}`,
            method: 'GET',
        });

        return normalizeDownloadResponse(response);
    },

    events(id, legalEntityId) {
        const query = legalEntityId
            ? `?legalEntityId=${encodeURIComponent(legalEntityId)}`
            : '';
        return fetch({
            url: `/api/billing-hub/v1/passive-invoices/${encodeURIComponent(id)}/events${query}`,
            method: 'GET',
        });
    },

};

export default PassiveInvoicesService;
